import React from 'react';
import MapChart from 'components/report-content/components/map-chart/MapChart';
import MapChartEditPanel from 'components/report-content/components/map-chart/MapChartEditPanel';
import { AbstractComponentBuilder, ComponentSettingsMapChart } from '@report-content';

export default class MapChartComponentBuilder extends AbstractComponentBuilder<ComponentSettingsMapChart> {
    getComponent() {
        return (
            <MapChart
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }

    getEditPanel() {
        if (this.contentSettings.context == 'view') {
            return null;
        }
        return (
            <MapChartEditPanel
                block={this.block}
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }
}
